import React, { useContext, useEffect, useState } from 'react'
import { CustomSection } from 'styles/GlobalStyle'
import { AssessmentDefsCrud } from './hooks'
import { Type, WrapContent, WrapSelectAssessment, C, WrapAssessmentSection, Semester, WrapAssessment, WrapTitle, AssessmentName, WrapFooter, Method, WordsLength } from './Style'
import { CheckBox } from 'components/Form'
import { useSelector } from 'react-redux'
import { keyBy } from 'lodash'
import { AbilityContext } from 'components/Permissions/Can'
import { SvgIcon } from '@mui/material'
import { ReactComponent as CIcon } from 'assets/icons/C.svg';

const Assessment = (props) => {
    const { selectAssessment, multiple = false, student, title, permission, footer, header, type_name, num_words, readability_score_name, name, visible_type, affiliation_name, layout_type: layoutTypeDef, author, id } = props
    const { user } = useSelector(state => state.user)
    const { selectedAssessmentDefs, selectedAssessmentDef } = useSelector(state => state.assessment)

    const ability = useContext(AbilityContext)

    const [balance, setBalance] = useState(user?.balance)

    const { goAssessment, updateAssessmentDefSelected } = AssessmentDefsCrud()

    const keyBySelectedAssessmentDefs = keyBy(selectedAssessmentDefs, "id")

    const onSelectAssessment = () => {
        if (props?.onSelectAssessment)
            props?.onSelectAssessment(props)
        else goAssessment(id, header, footer, student)
    }

    useEffect(() => {
        setBalance(user.balance)
    }, [user?.balance])

    return (
        <WrapAssessmentSection>
            {
                selectAssessment && //selectAssessment flag is on
                <WrapSelectAssessment>
                    <CheckBox
                        disabled={
                            ability.cannot("manage", "super-user") && !balance
                        }
                        input={{
                            value: multiple ? keyBySelectedAssessmentDefs[id] : selectedAssessmentDef?.id === id,
                            onChange: (selected) => {
                                if (selected && balance === selectedAssessmentDefs.length)
                                    alert("אין זכאות ליצרת מבדקים")
                                else
                                    updateAssessmentDefSelected({ id, name, layoutTypeDef, visible_type }, selected, multiple)
                            }
                        }} />
                </WrapSelectAssessment>}
            <CustomSection
                $bg
                height={200}
                width={300}
                $hover
                onClick={onSelectAssessment}
            >
                <WrapAssessment>
                    <WrapTitle>
                        <div className='type-and-c'>
                            <Type>
                                {type_name}
                            </Type>
                            {permission === 'PRIVATE' &&
                                <C>
                                    <SvgIcon fontSize="small" component={CIcon} inheritViewBox />
                                </C>}
                        </div>
                        <Semester>
                            {readability_score_name}
                        </Semester>
                    </WrapTitle>
                    <WrapContent>
                        <AssessmentName>{title}</AssessmentName>
                    </WrapContent>
                    <WrapFooter>
                        <Method $bg={"lightOrange"}>
                            {affiliation_name}{affiliation_name && author && ', '}{author}
                        </Method>
                        <WordsLength>{`${num_words} מילים`} </WordsLength>
                    </WrapFooter>
                </WrapAssessment>
            </CustomSection>
        </WrapAssessmentSection >
    )
}

export default Assessment